import { apiDelete, apiGet, apiPost, apiPut } from "./api-service";

export async function getAll() {
    try {
        const response = await apiGet('core', `equipment-list`);
        return response;
    } catch (e) { }
}

export async function getEquipmentList(type: string) {
    try {
        const response = await apiGet('core', `equipment-list?equipmentType=${type}`);
        return response?.content;
    } catch (e) { }
}

export async function add(newDetails: any) {
    const response = await apiPost('core', `equipment-list`, newDetails);
    return response?.content;
}

export async function equipmentImport(importId: number[]) {
    const response = await apiPost('core', `equipment-import-list`, { import: importId });
    return response?.content;
}

export async function update(id: string, newDetails: any) {
    const response = await apiPut('core', `equipment-list/${id}`, newDetails);
    console.log("response == ", response);
    return response?.content;
}

export async function removeEquipmentList(id: any) {
    try {

        return await apiDelete('core', `equipment-list/${id}`);
    } catch (e) { }
}